type ViewportZoomSyncOptions = {
  getZoom: () => number;
  onZoomChange: (zoom: number) => void;
  requestFrame?: (callback: () => void) => number;
  cancelFrame?: (handle: number) => void;
};

export const createViewportZoomSync = ({
  getZoom,
  onZoomChange,
  requestFrame = (callback) => requestAnimationFrame(callback),
  cancelFrame = (handle) => cancelAnimationFrame(handle),
}: ViewportZoomSyncOptions) => {
  let frame: number | null = null;
  let lastZoom = getZoom();

  const flush = () => {
    frame = null;

    const zoom = getZoom();
    if (zoom === lastZoom) return;

    lastZoom = zoom;
    onZoomChange(zoom);
  };

  return {
    schedule: () => {
      if (frame !== null) return;
      frame = requestFrame(flush);
    },

    stop: () => {
      if (frame === null) return;
      cancelFrame(frame);
      frame = null;
    },
  };
};
